module.exports = __webpack_public_path__ + "img/dw.5ab239cd.png";